export default {
  Id: '',
  Name: '',
};
